import { ZIPCODE_LENGTH } from '../../../../../constants/progressBanner'

export type EfoAddressState = {
    zip: string
    prefectureId: number | null
    cityId: number | null
    cityAddressId: number | null
    // 郵便番号から住所が確定している状態。確定中は都道府県・市区町村セレクトを固定する
    isZipResolved: boolean
}

export const initialEfoAddressState: EfoAddressState = {
    zip: '',
    prefectureId: null,
    cityId: null,
    cityAddressId: null,
    isZipResolved: false,
}

type ResolvedAddress = {
    prefectureId: number
    cityId: number
    cityAddressId: number
}

/** 郵便番号の入力（数字のみ・7桁まで）。入力し直したら確定済みの住所は解除する */
export const changeZip = (
    state: EfoAddressState,
    value: string
): EfoAddressState => {
    const zip = value.replace(/[^0-9]/g, '').slice(0, ZIPCODE_LENGTH.MAX)
    if (zip === state.zip) return state

    return { ...initialEfoAddressState, zip }
}

export const resolveZip = (
    state: EfoAddressState,
    address: ResolvedAddress
): EfoAddressState => ({
    ...state,
    prefectureId: address.prefectureId,
    cityId: address.cityId,
    cityAddressId: address.cityAddressId,
    isZipResolved: true,
})

export const failZip = (state: EfoAddressState): EfoAddressState => ({
    ...state,
    prefectureId: null,
    cityId: null,
    cityAddressId: null,
    isZipResolved: false,
})

/** 都道府県の選択。市区町村は選び直しになり、途中まで入力した郵便番号は捨てる */
export const selectPrefecture = (
    _state: EfoAddressState,
    prefectureId: number | null
): EfoAddressState => ({
    ...initialEfoAddressState,
    prefectureId,
})

/** 市区町村の選択。途中まで入力した郵便番号は捨てる */
export const selectCity = (
    state: EfoAddressState,
    cityId: number | null
): EfoAddressState => ({
    ...state,
    zip: '',
    cityId,
    cityAddressId: null,
    isZipResolved: false,
})

/** セレクトで住所を選び始めたら、郵便番号は入力させない */
export const isZipDisabled = (state: EfoAddressState): boolean =>
    !state.isZipResolved &&
    (state.prefectureId !== null || state.cityId !== null)

/** 「次へ」の活性条件。郵便番号で確定、または都道府県と市区町村が揃っていること */
export const isAddressComplete = (state: EfoAddressState): boolean =>
    state.isZipResolved || (state.prefectureId !== null && state.cityId !== null)

/**
 * 求人数ピルに出す件数。取得前・取得失敗（counts が null）の間は都道府県が決まっていても
 * 数字を出さない（null を返してモザイク表示を続ける）。0件の都道府県はキーを持たないため 0 に落とす
 */
export const resolveOfferCount = (
    counts: Record<string, number> | null,
    prefectureId: number | null
): number | null => {
    if (counts === null || prefectureId === null) return null

    return counts[String(prefectureId)] ?? 0
}
